<template>
    <router-link :to="{name: 'Popular', params: {id: article.id, page: 'about', url: article.attributes.url}}">
        <div class="card01 article-card">
            <div class="img"><img :src="article.attributes.thumbnail_url"></div>
            <div class="card-body01">
                <p class="card-text" v-html="article.attributes.title"></p>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: "ArticleCard",
        props: ['article']
    }
</script>

<style src="./ArticleCard.scss" lang="scss" scoped/>
